(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-idp/assets/javascripts/utils/iam-message-handler.js') >= 0) return;  svs.modules.push('/modules/iam-idp/assets/javascripts/utils/iam-message-handler.js');

'use strict';

const POST_MESSAGE_TYPES = svs.iam_idp.constants.POST_MESSAGE_TYPES;
const postMessageToParent = svs.iam_idp.utils.postMessageToParent;
const isInIamIframe = window.self !== window.top;
if (isInIamIframe) {
  var _svs;
  const TRUSTED_ORIGIN = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.iam_idp) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.origins) === null || _svs === void 0 ? void 0 : _svs.trusted;
  window.onload = function () {
    window.addEventListener('message', async event => {
      if (event.origin !== TRUSTED_ORIGIN && event.origin !== window.location.origin) {
      }
    });
  };
}
const resizeObserver = new ResizeObserver(entries => {
  for (const entry of entries) {
    const winHeight = entry.contentRect.height;
    postMessageToParent({
      value: winHeight,
      type: POST_MESSAGE_TYPES.HEIGHT
    });
  }
});

setTimeout(() => {
  resizeObserver.observe(document.getElementById('containerRegion'));
}, 500);

 })(window);